// import React from 'react';
import styled from 'styled-components';

const Quote = styled.p`
    // font-family: 'Georgia';
    font-family: 'Georgia Italic';
    // color: rgb(0, 114, 228);
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    font-style: italic;
    `;

export default Quote;